export default __webpack_public_path__ + "static/media/avatar-6.0ca0f7d0.png";